import {
    LOGIN_IN_PROGRESS,
	LOGIN_FAILED,
	LOGIN_SUCCESSFUL
} from '../actions/loginAction';
// import { REHYDRATE } from 'redux-persist';

export default (state=false,action)=>{
    switch(action.type){
        // case REHYDRATE:
        //  return {
        // ...state,
        // user: action.payload && action.payload.user
        // };
        case LOGIN_IN_PROGRESS:
        return true;
        case LOGIN_SUCCESSFUL:
        return action.data
        case LOGIN_FAILED:
        return action.data;
        default:
        return state;
    }
}